import axios from 'axios'
// config
import { BACKEND_API } from '../config'

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: BACKEND_API,
  timeout: 15000 * 10, // Long timeout allowance because API request can take some time
  'Content-Type': 'application/json',
  accept: 'application/json',
})

const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken')
  if (!refreshToken) {
    throw new Error('No refresh token available')
  }

  try {
    const response = await axios.post(`api/token/refresh/`, {
      refresh: refreshToken,
    })
    
    const { access } = response.data
    localStorage.setItem('accessToken', access)
    return access
  } catch (error) {
    // If refresh fails, clear tokens and redirect to login
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    window.location.href = '/auth/login'
    throw error
  }
}

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 403) {
      // redirect to blocked page
      window.location.href = '/blocked'
      return Promise.reject(error)
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        const newAccessToken = await refreshAccessToken()
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
        return axiosInstance(originalRequest)
      } catch (refreshError) {
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(
      (error.response && error.response.data) || 'Something went wrong',
    )
  },
)

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
)

export default axiosInstance
